// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {createSelector} from 'reselect';

import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';
import {getChannelStats} from 'mattermost-redux/selectors/entities/channels';
import {getCurrentUserMentionKeys, UserMentionKey} from 'mattermost-redux/selectors/entities/users';
import {getMyGroupMentionKeys} from 'mattermost-redux/selectors/entities/groups';
import {isChannelPinnedPostsEnabled} from 'mattermost-redux/selectors/entities/preferences';

import {GlobalState} from 'mattermost-redux/types/store';

export const getCurrentSearchForCurrentTeam: (state: GlobalState) => string = createSelector(
    (state: GlobalState) => state.entities.search.current,
    getCurrentTeamId,
    (current, teamId) => {
        return current[teamId];
    },
);

export const getAllUserMentionKeys: (state: GlobalState) => UserMentionKey[] = createSelector(
    getCurrentUserMentionKeys,
    getMyGroupMentionKeys,
    (userMentionKeys, groupMentionKeys) => {
        return userMentionKeys.concat(groupMentionKeys);
    },
);

export function getChannelPinnedPostIds(state: GlobalState, channelId: string): string[] | undefined {
    return state.entities.search.pinned[channelId];
}

export function getAllPinnedPostsIds(state: GlobalState): string[] {
    return Object.values(state.entities.search.pinned).flat();
}

export function getChannelPinnedPostCount(state: GlobalState, channelId: string): number | undefined {
    return getChannelStats(state, channelId)?.pinnedpost_count;
}

export function showChannelPinnedPostsPanel(state: GlobalState, channelId: string): boolean {
    if (!isChannelPinnedPostsEnabled(state)) {
        return false;
    }
    return (
        Boolean(getChannelPinnedPostCount(state, channelId)) ||
        Boolean(getChannelPinnedPostIds(state, channelId)?.length)
    );
}
